import { SanityProductVariantOption } from '@data/sanity/queries/types/product'
import { ClientBrowserParameters } from '@shopify/hydrogen-react'

export interface AnalyticsSettings {
  googleEvents: boolean
  shopifyEvents: boolean
}

export interface ProductVariantEventInput {
  variantId: number
  options: SanityProductVariantOption[]
  price: number
  comparePrice: number
  quantity: number
}

export enum AnalyticsEventType {
  GoogleTagManager = 'Google Tag Manager',
  Shopify = 'Shopify',
}

export enum AnalyticsEventName {
  AddToCart = 'Add to cart',
  InitiateCheckout = 'Initiate checkout',
  NewsletterSignUp = 'Newsletter sign up',
  Pageview = 'Pageview',
  RemoveFromCart = 'Remove from cart',
  Signup = 'Signup',
  ViewProduct = 'View product',
}

export type EventPayload = Record<string, unknown>

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_cart_item
interface GoogleProductEventPayloadItem {
  index: number
  item_id: string
  item_name?: string
  item_variant?: string
  price?: number
  discount?: number
  quantity: number
}

export interface GoogleProductEventPayload {
  items: GoogleProductEventPayloadItem[]
}

// https://developers.facebook.com/docs/meta-pixel/reference
interface MetaProductEventPayloadContent {
  id: string
  quantity: number
}

export interface MetaProductEventPayload {
  content_category?: string
  content_ids?: number[] | string[]
  content_name?: string
  content_type: 'product' | 'product_group'
  contents?: MetaProductEventPayloadContent[]
}

export interface AnalyticsEvent {
  id: string
  type: AnalyticsEventType
  name: AnalyticsEventName
  eventPayload?: EventPayload
}

export type ShopifyEventPayload = ClientBrowserParameters & EventPayload

export interface CookieConsentStatus {
  necessary: boolean
  preferences: boolean
  statistics: boolean
  marketing: boolean
}
